import { useCurrentUser } from '@/features/users/users.hooks';
import { useFeedbackForUser } from '@/features/feedback/feedback.queries';

/**
 * Hook that fetches feedback submitted by the currently authenticated user.
 * Returns the standard TanStack Query result with data sorted newest-first.
 */
export function useMyFeedback() {
  const user = useCurrentUser();
  const query = useFeedbackForUser(user?.recnum ?? 0);

  const sorted = query.data
    ? [...query.data].sort(
        (a, b) => b.timestamp.getTime() - a.timestamp.getTime(),
      )
    : undefined;

  return {
    ...query,
    data: sorted,
  };
}
